import { customFetch } from '../lib/network/Axios';
import type {
  CreateWaitlistReferralLinkPayload,
  CreateWaitlistReferralLinkResponse,
  SiteRequestListResponse,
  SiteRequestType,
  WaitlistReferralLinkListResponse,
} from '../types/siteRequest.types';

export async function getSiteRequests(params: {
  page: number;
  limit: number;
  type?: SiteRequestType;
  search?: string;
}): Promise<SiteRequestListResponse> {
  const response = await customFetch.get('/site-requests', {
    params: {
      ...params,
      search: params.search?.trim() || undefined,
    },
  });
  return response.data as SiteRequestListResponse;
}

export async function createWaitlistReferralLink(
  payload: CreateWaitlistReferralLinkPayload,
): Promise<CreateWaitlistReferralLinkResponse> {
  const response = await customFetch.post('/site-requests/waitlist-referral-links', payload);
  return response.data as CreateWaitlistReferralLinkResponse;
}

export async function getWaitlistReferralLinks(params: {
  page: number;
  limit: number;
}): Promise<WaitlistReferralLinkListResponse> {
  const response = await customFetch.get('/site-requests/waitlist-referral-links', { params });
  return response.data as WaitlistReferralLinkListResponse;
}

export async function deleteWaitlistReferralLink(id: number): Promise<void> {
  await customFetch.delete(`/site-requests/waitlist-referral-links/${id}`);
}
